import React, { lazy } from "react";

const LazyApprovals = lazy(() => import("./Approvals"));

const Approvals = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyApprovals {...props} />;

export default Approvals;
